export enum TicketState {
  NEW = 'new',
  PENDING = 'pending',
  DONE = 'done',
  CLOSED = 'closed',
}
